import { render } from "./DiscoverChatNavigation.vue?vue&type=template&id=acc2ab90"
import script from "./DiscoverChatNavigation.vue?vue&type=script&lang=js"
export * from "./DiscoverChatNavigation.vue?vue&type=script&lang=js"

import "./DiscoverChatNavigation.vue?vue&type=style&index=0&id=acc2ab90&lang=css"
script.render = render

export default script